import { useTranslation } from '@crehana/i18n';
import { Button } from "../../../Button";
import locales from "../../i18n";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var FilterFooter = function FilterFooter() {
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var t = locales[languageCode];
  return /*#__PURE__*/_jsx("div", {
    className: "tw-sticky tw-bg-neutral-light-200 tw-b-0 tw-w-full tw-px-2.4 tw-py-1.6 tw-flex tw-w-full tw-justify-end tw-items-center dark:tw-bg-elevation-dark-02",
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: function onClick() {},
        className: "tw-text-link-s hover:tw-text-neutral-light-700 tw-cursor-pointer tw-text-neutral-light-700 tw-mr-2.4",
        children: t.SAVE_FILTERS_BUTTON_CANCEL
      }), /*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "primary",
        size: "xs",
        onClick: function onClick() {},
        children: t.SAVE_FILTERS_BUTTON_SAVE
      })]
    })
  });
};